import { ResourceName } from "@/types";

/**
 * The record type a document can attach to — ADR-086's `attachment_target_type`
 * enum (`policy | claimant | client | vendor`). #6507 wires the policy instance
 * of {@link DocumentsPanel}; #6506 adds claimant; client/vendor adopt later with
 * no schema or API change (the enum already carries all four members).
 */
export type AttachmentRecordType = "policy" | "claimant" | "client" | "vendor";

/**
 * Resource path segment for the attachment sub-collection route
 * (`GET|POST /{segment}/{id}/attachments`, `DELETE …/{documentId}`).
 */
export const ATTACHMENT_RECORD_SEGMENT: Record<AttachmentRecordType, ResourceName> = {
  policy: ResourceName.POLICIES,
  claimant: ResourceName.CLAIMANTS,
  client: ResourceName.CLIENTS,
  vendor: ResourceName.VENDORS,
};

/** Singular, user-facing noun for a record type — used in "Remove from {noun}". */
export const ATTACHMENT_RECORD_NOUN: Record<AttachmentRecordType, string> = {
  policy: "policy",
  claimant: "claimant",
  client: "client",
  vendor: "vendor",
};
